import React from 'react'

import { useOrdersFiltersContext } from '../assets-filter-list/orders-filter-context'
import { ConfirmedOrder } from '../orders-detail/orders-types'
import { ModalTemplate } from './modal-template'
import { PriceCorrectionForm } from './price-correction-form'

interface OrderCorrectPriceModalProps {
  isOpen: boolean
  onClose: () => void
  order: ConfirmedOrder
}
export const OrderCorrectPriceModal = ({ isOpen, onClose, order }: OrderCorrectPriceModalProps) => {
  const { asset } = useOrdersFiltersContext()

  return (
    <ModalTemplate
      body={<PriceCorrectionForm order={order} onClose={onClose} />}
      header={`${asset.name} - Price correction`}
      isOpen={isOpen}
      onClose={onClose}
    />
  )
}
